export const passwordConstants = {
  RECOVERY_EMAIL_SUBMIT_REQUEST: "RECOVERY_EMAIL_SUBMIT_REQUEST",
  RECOVERY_EMAIL_SUBMIT_SUCCESS: "RECOVERY_EMAIL_SUBMIT_SUCCESS",
  RECOVERY_EMAIL_SUBMIT_FAILURE: "RECOVERY_EMAIL_SUBMIT_FAILURE",
  SET_PASSWORD_SUBMIT_REQUEST: "SET_PASSWORD_SUBMIT_REQUEST",
  SET_PASSWORD_SUBMIT_SUCCESS: "SET_PASSWORD_SUBMIT_SUCCESS",
  SET_PASSWORD_SUBMIT_FAILURE: "SET_PASSWORD_SUBMIT_FAILURE",
  SET_PASSWORD_WITH_TOKEN_SUBMIT_REQUEST:
    "SET_PASSWORD_WITH_TOKEN_SUBMIT_REQUEST",
  SET_PASSWORD_WITH_TOKEN_SUBMIT_SUCCESS:
    "SET_PASSWORD_WITH_TOKEN_SUBMIT_SUCCESS",
  SET_PASSWORD_WITH_TOKEN_SUBMIT_FAILURE:
    "SET_PASSWORD_WITH_TOKEN_SUBMIT_FAILURE"
};
